// extracted by mini-css-extract-plugin
module.exports = {"root":"Note_root__39xyo","info":"Note_info__3heKW","note":"Note_note__12w4s","actions":"Note_actions__30vLE"};